/*
|-------------------------------------------------------------------------------
| 申卡介绍页
|-------------------------------------------------------------------------------
*/
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'

const IntroPageStore = defineStore({
  state: () => ({
    topImage: '', // 顶部卡片图片
    bottomImage: '', // 底部卡片图片
  }),
  mutations: {
    update(state, data) {
      Object.assign(state, data)
    },
  },
})

export default IntroPageStore
export type IIntroPageStoreState = IStoreState<
  typeof IntroPageStore.state
>
